import { useEffect } from "react"

import { ITableColumn } from "../components/TableColumns"
import {
  DEFAULT_COLUMN_WIDTH,
  FIRST_COLUMN_WIDTH,
} from "../constants"
import { useTableContext } from "../provider"

export const useColumnsCombine = () => {

  const ctx = useTableContext()
  const { columns } = ctx.props

  useEffect(() => {
    const userColumns: ITableColumn[] = setColumnProperties(columns)

    ctx.columns.api.setCombined(userColumns)

  }, [])

  return {}
}

const setColumnProperties = (columns: ITableColumn[]): ITableColumn[] =>
  columns.map((item, index, array) => ({
    index,
    default: false,
    disableReorder: item.disableReorder || index === 0,
    flex: item.flex || (index === 0 ? FIRST_COLUMN_WIDTH : DEFAULT_COLUMN_WIDTH),
    hidden: false,
    isLocked: false,
    sortable: false,
    tooltip: false,
    ...item,
  }))
